var map = {
	"./alaska.jpg": 38,
	"./australia.jpg": 39,
	"./england.jpg": 40,
	"./goa.jpg": 41,
	"./greek.jpg": 42,
	"./greenland.jpg": 43,
	"./hongkong.jpg": 44,
	"./iceland.jpg": 45,
	"./image.jpg": 46,
	"./italy.jpg": 47,
	"./kashmir.jpg": 48,
	"./kerala.jpg": 49,
	"./newyork.jpg": 50,
	"./norway.jpg": 51,
	"./paris.jpg": 52,
	"./singapore.jpg": 53,
	"./thailand.jpg": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;